"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processElementsInChildren = exports.getElementsInChildren = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
function getElementsInChildren(children, elementType) {
    var result = [];
    findElementsInChildrenShallow(children, elementType, function (requiredElement) { return result.push(requiredElement); }, function (otherElement) {
        result.push.apply(result, getElementsInChildren(otherElement.props.children, elementType));
    });
    return result;
}
exports.getElementsInChildren = getElementsInChildren;
function processElementsInChildren(children, elementType, handler) {
    var newChildren = [];
    findElementsInChildrenShallow(children, elementType, function (requiredElement) { return newChildren.push(handler(requiredElement)); }, function (otherElement) {
        var _a;
        var nextLevelChildren = processElementsInChildren(otherElement.props.children, elementType, handler);
        var key = (_a = nextLevelChildren[0]) === null || _a === void 0 ? void 0 : _a.key;
        var processedParent = react_1.cloneElement.apply(void 0, tslib_1.__spreadArray([otherElement,
            {
                key: key || otherElement.key,
            }], nextLevelChildren));
        newChildren.push(processedParent);
    });
    return newChildren;
}
exports.processElementsInChildren = processElementsInChildren;
function findElementsInChildrenShallow(children, type, resolve, reject) {
    react_1.Children.forEach(children, function (child) {
        if (!react_1.isValidElement(child)) {
            return;
        }
        if (child.type === type) {
            resolve(child);
        }
        else {
            reject === null || reject === void 0 ? void 0 : reject(child);
        }
    });
}
